export const planListFromDto = (dto) => ({
  id: dto.id,
  name: dto.name,
  active: dto.active,
});

export const planFromDto = (dto) => ({
  ...planListFromDto(dto),
  rates: dto.rates, // TODO: Mapear
  coverage_configs: dto.coverage_configs, // TODO: Mapear
});

export const planCreateToDto = (data) => ({
  name: data.name,
});

export const planUpdateToDto = (data) => ({
  ...planCreateToDto(data), // Reutiliza los campos de creación y deja preparado el objeto para añadir campos específicos al actualizar
});